import { useMutation, useQueryClient } from "@tanstack/react-query";
import { USE_RETRIEVE_INTRA_SQUAD_MATCH } from "../ApiProvider";
import { api } from "./api";
import { USE_RETRIEVE_PLAYER_FEED, USE_RETRIEVE_TEAM_FEED } from "./queryKeys";
export const useDeleteIntraSquadMatch = ({ intraSquadMatch, team, onMutate, onSuccess, onError, }) => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async () => {
            if (!intraSquadMatch) {
                throw new Error("IntraSquadMatch is undefined");
            }
            return api.delete(`/intra-squad-matches/${intraSquadMatch.id}/`);
        },
        onMutate,
        onSuccess: (data) => {
            queryClient.invalidateQueries([
                USE_RETRIEVE_TEAM_FEED,
                intraSquadMatch?.team,
            ]);
            team?.players?.forEach((playerId) => {
                queryClient.invalidateQueries([USE_RETRIEVE_PLAYER_FEED, playerId]);
            });
            queryClient.removeQueries([
                USE_RETRIEVE_INTRA_SQUAD_MATCH,
                intraSquadMatch?.id,
            ]);
            onSuccess(data);
        },
        onError,
    });
};
